import { ReactNode } from "react";

interface iButtonProps{
    onClick?: ()=>void
    children: ReactNode
}

export default function Button({onClick, children}:iButtonProps){

    return(

        <button
            className="py-2 px-4 rounded text-primary capitalize cursor-pointer no-underline flex justify-center items-center w-full"
            onClick={onClick}
        >
            {children}
        </button>

    )

}

export function PrimaryButton({onClick, children}:iButtonProps){

    return(

        <button
            className="py-2 px-4 rounded capitalize cursor-pointer no-underline flex justify-center items-center w-full   text-light_col bg-primary border border-solid border-primary duration-300"
            onClick={onClick}
        >
            {children}
        </button>

    )

}

export function AccentButton({onClick, children}:iButtonProps){

    return(

        <button
            className="py-2 px-4 rounded text-primary capitalize cursor-pointer no-underline flex justify-center items-center w-full    bg-secondary border border-solid border-secondary duration-300"
            onClick={onClick}
        >
            {children}
        </button>

    )

}

export function BorderButton({onClick, children}:iButtonProps){

    return(

        <button
            className="py-2 px-4 rounded capitalize cursor-pointer no-underline flex justify-center items-center w-full  text-secondary2 border border-solid border-secondary2 duration-300"
            onClick={onClick}
        >
            {children}
        </button>

    )

}

